module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Book-e3afb936fae7bb58d0e63d898cd76898.woff2";